import { useAuth, useOutletApi } from "@/features/authentication";
import { PermissionEnum } from "@/features/permissions";
import { usePendingCount } from "@/hooks";

// Dispatched on window after a conversion so the drawer badge drops immediately
// instead of waiting for the next poll.
export const INCOMING_PURCHASE_RETURNS_CHANGED_EVENT =
  "incoming-purchase-returns:changed";

/**
 * How many purchase returns are waiting for this outlet to mirror them as a
 * sales return. Seller-scoped, so it follows the active outlet.
 *
 * Returns 0 without issuing a request when the active outlet is not a hub — a
 * retail outlet is never the seller on an internal return.
 */
export const useIncomingPurchaseReturnsCount = () => {
  const { outlet, isHubOutlet, hasPermission } = useAuth();
  const api = useOutletApi();

  return usePendingCount({
    api,
    url: "purchase-returns/incoming",
    enabled:
      !!outlet?.id &&
      isHubOutlet &&
      hasPermission(PermissionEnum.READ_PURCHASE_RETURNS),
    changedEvent: INCOMING_PURCHASE_RETURNS_CHANGED_EVENT,
  });
};
